import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=6af5d750&scoped=true&"
import script from "./checkbox.vue?vue&type=script&lang=ts&"
export * from "./checkbox.vue?vue&type=script&lang=ts&"
import style0 from "./checkbox.vue?vue&type=style&index=0&id=6af5d750&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af5d750",
  null
  
)

export default component.exports